import React from "react";
import { Route } from "react-router-dom";

import LCR from "./LCR";
import NFSR from "./NFSR";

export default function LiquidityRatio({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route path={`${match.url}/lcr`} component={LCR} />
        <Route path={`${match.url}/nfsr`} component={NFSR} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/LiquidityRatio/index.js